











import { Component, Vue } from 'vue-property-decorator';
import CloseIcon from '@/assets/icons/close.svg';
import Item from '@vuex-orm/core/lib/data/Item';
import Marker from '@/marker/Marker';

@Component({
    components: {
        CloseIcon,
    },
})
export default class MarkerDetailsEmbed extends Vue {
    private get marker(): Item<Marker> {
        const id = this.$route.params.marker;

        return Marker.query()
            .whereId(id)
            .withAllRecursive()
            .first();
    }

    mounted() {
        this.$nextTick(() => {
            this.$modal.show('embed');
        });
    }

    beforeClose() {
        this.$emit('close');
    }
}
